import { get }                    from '@rails/request.js'
import $fq                        from '../../support/fake_query'
import WizardMixin                from '../../support/wizard_mixin'
import BmiMixin                   from '../../support/bmi_mixin'
import ConsultationNoteController from '../consultation_note_controller'
import EscalationMixin            from '../../support/escalation_mixin'
import GlucoseIndicatorMixin      from '../../support/glucose_indicator_mixin'
import ScrollToErrorMixin         from '../../support/scroll_to_error_mixin'
import Vo2MaxMixin                from '../../support/vo2_max_mixin'
import ThreeMinStepTestMixin      from '../../support/three_min_step_test_mixin'
import mixin                      from '../../support/mixin'

export default class extends mixin(
  ConsultationNoteController,
  WizardMixin,
  BmiMixin,
  GlucoseIndicatorMixin,
  EscalationMixin,
  ScrollToErrorMixin,
  Vo2MaxMixin,
  ThreeMinStepTestMixin
) {

  static targets = [
    ...super.targets,
    'editFormContainer',
    'hivConfirmationSection',
    'testStripDetails'
  ]

  static values = {
    ...super.values,
    showTestStrip: Boolean
  }

  static classes = [
    'hide'
  ]

  connect() {
    super.connect()
  }

  initialize() {
    super.initialize()
  }

  // ==== Controllers

  // ==== Actions

  async checkRange(event) {
    const element = event.currentTarget

    if (element.value === element.dataset.capturedValue) return

    const queryData = new FormData()

    queryData.append(element.name, element.value)

    const response = await get(
      this.rangeCheckUrlValue,
      {
        query:        queryData,
        responseKind: 'turbo-stream'
      }
    )

    if (response.ok) {
      this.outOfRangePopoverTargets.forEach((elPopover) => {
        if (!$fq(elPopover).hasClass(this.hideClass)) {
          $fq(elPopover).hide()
        }
      })

      this.outOfRangeGlyphTargets.forEach((elGlyph) => {
        $fq(elGlyph).changeGlyph('#exclamation-circle')
      })
    }
  }

  togglePrint(event) {
    const element = event.currentTarget

    if (element.innerHTML === '') {
      $fq(this.editFormContainerTarget).removeClass(this.hideClass)
      this.autoSaveEnabledValue = true
    } else {
      $fq(this.editFormContainerTarget).addClass(this.hideClass)
      this.autoSaveEnabledValue = false
    }
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  toggleTestStrip(event) {
    const element = event.currentTarget
    this.showTestStripValue = element.checked
  }

  toggleHivSelections(event) {
    const value = event.currentTarget.value

    if (value === '3' || value === '1') {
      $fq(this.hivConfirmationSectionTarget).removeClass(this.hideClass)
    } else {
      $fq(this.hivConfirmationSectionTarget).addClass(this.hideClass)
    }
  }

  // ==== Channels

  // ==== Callbacks

  showTestStripValueChanged() {
    if (this.showTestStripValue) {
      $fq(this.testStripDetailsTarget).removeClass(this.hideClass)
    } else {
      $fq(this.testStripDetailsTarget).addClass(this.hideClass)
    }
  }

}
